class User{

 constructor(id, email, name, lastname, type, phone, active){
   this.id = id
   this.email = email || ''
   this.name = name || ''
   this.lastname = lastname || ''
   this.type = type || ''
   this.phone = phone || ''
   this.password = ""
   this.confirmPassword = ""
   this.active = active || 0
 }

 static parse(responseData){
   if (!responseData) return new User()
   let d = responseData
   return new User(d.id, d.email, d.name, d.lastname,d.admin_type,d.phone, d.active)
 }


}

export default User



// WEBPACK FOOTER //
// ./src/models/user.js